import { defineMessages, useIntl } from 'react-intl';
import { Typography, Box, useDeviceType, LoginButton } from '@packages/shared';
import { useSession } from '@packages/utilities';
import { Wishlist32 } from '@packages/themes/icons';
import useSWR from 'swr';
import { LoginDialogComposed } from '../../../LoginDialog';
import { Slot } from './Slot';

const messages = defineMessages({
  title: {
    id: 'slot.wishlist.label',
    defaultMessage: 'Merkzettel',
  },
  overlayHeadline: {
    id: 'slot.wishlist.overlay.headline',
    defaultMessage: 'Du vermisst Artikel, die du dir gemerkt hast?',
  },
  overlayContent: {
    id: 'slot.wishlist.overlay.content',
    defaultMessage: 'Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
});

const DesktopPopoverContent = ({ onLogin }: { onLogin: () => void }) => {
  const { formatMessage } = useIntl();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, pt: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {formatMessage(messages.overlayHeadline)}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {formatMessage(messages.overlayContent)}
      </Typography>
      <Box sx={{ alignSelf: 'flex-end' }}>
        <LoginButton fullWidth onClick={onLogin} />
      </Box>
    </Box>
  );
};

// TODO(api-layer): remove unnecessary fetcher when connected to api-layer
const skusFetcher = async ([url, token]: Array<string>): Promise<{
  wishlist: Array<string>;
  size: number;
}> =>
  fetch(url, { headers: { 'x-ec-token': token } }).then((res) => {
    if (!res.ok) {
      throw new Error(`Get skus from wishlist error: Status ${res.status}: ${res.statusText}`);
    }
    return res.json();
  });

/** Wishlist slot with count badge and login popover. On mobile devices the slot is a link and has no popover */
export const WishlistSlot = () => {
  const { formatMessage } = useIntl();
  const { isMobile } = useDeviceType();
  const { jwtToken, loggedIn } = useSession();

  const { data } = useSWR(jwtToken ? ['/api/wishlist/v1/skus', jwtToken] : null, skusFetcher);

  return (
    <LoginDialogComposed>
      {(openLoginDialog) => (
        <Slot
          useRouterLink={false}
          icon={<Wishlist32 />}
          badgeCount={data?.size}
          title={formatMessage(messages.title)}
          href="/merkzettel"
        >
          {!isMobile && !loggedIn && data?.size === 0 && (
            <DesktopPopoverContent onLogin={openLoginDialog} />
          )}
        </Slot>
      )}
    </LoginDialogComposed>
  );
};
